import { useEffect, useState, type FC } from "react";
import { Stack } from "@mui/material";

import { type Association } from "@entities";
import type { CustomCell } from "./types";

const ActivityStatus: FC<CustomCell<Association>> = ({ row }) => {
  const [backgroundColor, setBackgroundColor] = useState<
    | "#F9B035" /*Orange*/
    | "#06D6A0" /*Green*/
    | "#EF476F" /*Red*/
    | "#5B8DEF" /*Blue*/
    | "#9CA3AF" /*Gray*/
  >("#06D6A0");

  const TO_HEB: Record<string, string> = {
    NEW: "חדש",
    ACTIVE: "פעיל",
    INACTIVE: "לא פעיל",
    LEGACY: "מאגר ישן",
  };

  const englishStatus = (row.original.activityStatus ?? "INACTIVE") as string;
  const hebStatus = TO_HEB[englishStatus] ?? "לא ידוע";

  useEffect(() => {
    switch (englishStatus) {
      case "NEW":
        setBackgroundColor("#F9B035"); // Orange
        return;
      case "ACTIVE":
        setBackgroundColor("#06D6A0"); // Green
        return;
      case "INACTIVE":
        setBackgroundColor("#EF476F"); // Red
        return;
      case "LEGACY":
        setBackgroundColor("#5B8DEF"); // Blue
        return;
      default:
        setBackgroundColor("#9CA3AF"); // Gray
        return;
    }
  }, [englishStatus]);

  return (
    <Stack flexDirection="row" alignItems="center" gap="2%">
      <Stack
        sx={{
          backgroundColor,
          height: "15px",
          width: "15px",
          borderRadius: "14px",
        }}
      />
      <span title={hebStatus}>{hebStatus}</span>
    </Stack>
  );
};

export default ActivityStatus;
